import { Tooltip } from '@mui/material'

interface HeaderCellWithTooltipProps {
  children: React.ReactNode
  label: string
  sublabel?: string
}

const HeaderCellWithTooltip = ({
  children,
  label,
  sublabel,
}: HeaderCellWithTooltipProps) => {
  const title = sublabel ? `${label} — ${sublabel}` : label

  return (
    <Tooltip placement="top-start" title={title}>
      <span style={{ display: 'inline' }}>{children}</span>
    </Tooltip>
  )
}

export default HeaderCellWithTooltip
